import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { AddCircleRounded, ArrowBack, Info } from "@mui/icons-material";
import { Stage } from "./changeStage";
import { setWordCase } from "../../assets/library";
import { useAppDispatch } from "../../assets/hooks";
import { setPopup } from "../../store/slices/popupSlice";
import Images from "../../assets";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { cancellation, editChecklist } from "../../services";

const Application = () => {
  const { id } = useParams();
  const [applicationData, setApplicationData] = useState<any>();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [checklist, setChecklist] = useState<any[]>([]);
  const [status, setStatus] = useState<string>("");
  const [cancel, setCancel] = useState<boolean>();

  const role = localStorage.getItem("role")
  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("_auth_token");
      if (!token) {
        localStorage.clear();
        navigate("/");
      }
      try {
        setLoading(true);
        const { data } = await axios.get(
          `https://campusroot.com/api/v1/member/applications/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setLoading(false);
        setApplicationData(data.data);
        setChecklist(data.data?.docChecklist);
        setStatus(data?.data?.status);
        setCancel(data?.data?.cancellationRequest);
      } catch (error) {
        setLoading(false);
        console.error(
          "Error fetching student data:"
          // error.response.data.message
        );
      }
    };
    fetchData();
    // eslint-disable-next-line
  }, []);

  const handleDelete = async (item: string) => {
    const response = await editChecklist({
      applicationId: applicationData?._id,
      checklistItemId: item,
      action: "delete",
    });
    if (response.data.success) {
      const updatedArray = checklist?.filter((value) => value._id !== item);
      setChecklist(updatedArray);
    } else if (response.data.success === false) {
      // setError(response.data.message);
    }
  };

  const handleCancellation = async (value: string) => {
    setLoading(true);

    const response = await cancellation({
      cancel: value,
      applicationId: applicationData?._id,
    });
    if (response) {
      if (value === "true") {
        setCancel(false);
      } else {
        setCancel(response?.data?.data?.cancellationRequest);
      }
    }
    setLoading(false);
  };

  const handleChecked = async (item:any) => {
    if(role === "processCoordinator"){
      setLoading(true);
      const response = await editChecklist(
        {
          isChecked: !item?.isChecked,
          applicationId: applicationData?._id,
          checklistItemId: item?._id,
          action: "edit",
        }
      );
      if (response.data.success) {
        setChecklist(response?.data?.data?.docChecklist);
      } else if (response.data.success === false) {
        
      }
      setLoading(false);
    }
  
  };

  const details = [
    { label: "University", value: applicationData?.course?.university?.name },
    {
      label: "Location",
      value: `${applicationData?.course?.university?.location?.city}, ${applicationData?.ucourse?.niversity?.location?.state}, ${applicationData?.course?.university?.location?.country}`,
    },
    {
      label: "Course",
      value: `${applicationData?.course?.name} - ${applicationData?.course?.subDiscipline}`,
    },
    { label: "Study Level", value: applicationData?.course?.studyLevel },
    { label: "Duration", value: `${applicationData?.course?.duration.reduce((acc:string,curr:any,i:number)=>(acc+(`${curr?.durationType}:${curr?.duration}`)+(i<applicationData?.course?.duration?.length-1?",":"")),"")
                }} months` },
    {
      label: "Established Year",
      value: applicationData?.course?.university?.establishedYear,
    },
    { label: "Type", value: setWordCase(applicationData?.course?.university?.type) },
    {
      label: "Intake",
      value: new Date(applicationData?.intake).toLocaleDateString(),
    },
    { label: "Status", value: status },
    {
      label: "Stage",
      value: (
        <Stage
          stage={applicationData?.stage}
          id={applicationData?._id}
          status={applicationData?.status}
          setStatus={setStatus}
        />
      ),
    },
    {
      label: "Deadline",
      value: applicationData?.deadline
        ? new Date(applicationData?.deadline).toLocaleDateString()
        : "Not specified",
    },
    {
      label: "Process Coordinator",
      value: setWordCase(applicationData?.processCoordinator?.firstName),
    },
    {
      label: "Counsellor",
      value: setWordCase(applicationData?.counsellor?.firstName),
    },
  ];

  return (
    <div className="container">
      {loading ? (
        <p>Loading...</p>
      ) : applicationData ? (
        <div>
          <Box
            sx={{
              background: "#3B3F76",
              padding: "8px 24px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: "15px",
              }}
            >
              <Button
                onClick={() => navigate("/dashboard")}
                sx={{
                  color: "#fff",
                  // borderBottom: activeTab === "leads" ? "2px solid #fff" : 0,
                  borderRadius: 0,
                  textTransform: "none",
                  fontSize: "1rem",
                }}
              >
                <ArrowBack sx={{ color: "#fff" }} />
                Previous page
              </Button>
            </Box>
          </Box>
          <h2 style={{ textAlign: "center" }}>Application Details</h2>
          <Grid container spacing={4} sx={{ p: 2 }}>
            <Grid item xs={3} sx={{ px: 2 }}>
              <Box sx={{ background: "#FCF1EE", p: 2 }}>
                <Box
                  sx={{
                    background: "#fff",
                    p: 1,
                    borderRadius: "10px",
                    mb: 1,
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  <Avatar
                    src={
                      applicationData?.user?.displayPicSrc
                        ? applicationData?.user?.displayPicSrc
                        : "https://res.cloudinary.com/dffdp7skh/image/upload/v1706879929/nvitahnrlhvmtcizpthx.png"
                    }
                    alt="logo"
                    sx={{
                      width: "2.5rem",
                      height: "2.5rem",
                      borderRadius: "50%",
                    }}
                  />
                  <Box>
                    <Typography fontSize="0.9rem">
                      {applicationData?.user?.firstName}{" "}
                      {applicationData?.user?.lastName}
                    </Typography>
                    <Typography fontSize="0.8rem">{applicationData?.user?.email}</Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    background: "#fff",
                    p: 1,
                    borderRadius: "10px",
                    mb: 1,
                    gap: "10px",
                    textAlign: "center",
                  }}
                >
                  <Link
                    to={`/student/${applicationData.user._id}/personal`}
                    target="_blank"
                    style={{ textDecoration: "none" }}
                  >
                    View profile
                  </Link>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={9} sx={{ p: 3 }}>
              <Box
                className="card"
                sx={{ boxShadow: 3, p: 2, borderRadius: "10px", mb: 2 }}
              >
                <Grid container>
                  {details.map((detail, index) => (
                    <Grid
                      item
                      xs={6}
                      sx={{ display: "flex", p: 1 }}
                      key={index}
                    >
                      <Typography
                        sx={{
                          minWidth: 150,
                          color: "#7C7A7A",
                          fontSize: "14px",
                        }}
                      >
                        {detail.label}
                      </Typography>
                      <Typography fontSize="0.9rem">{detail.value}</Typography>
                    </Grid>
                  ))}
                  {role === "counsellor" ? "" :
                  <Grid item xs={12}>
                    {cancel ? (
                      <Box style={{ marginTop: "2%", padding: "1rem" }}>
                        <h3>Cancellation </h3>
                        <Stack
                          spacing={2}
                          direction="row"
                          sx={{
                            display: "flex",
                            marginTop: "1rem",
                          }}
                        >
                          <Button
                            sx={{
                              m: 2,
                              borderRadius: "10px",
                              textTransform: "none",
                              fontSize: "0.9rem",
                              background: "#316539",
                              color: "#fff",
                              "&:hover": {
                                background: "#316539",
                              },
                            }}
                            onClick={() => handleCancellation("true")}
                          >
                            Proceed with the request
                          </Button>
                          <Button
                            sx={[
                              {
                                m: 2,
                                borderRadius: "10px",
                                textTransform: "none",
                                fontSize: "0.9rem",
                                background: "red",
                                color: "#fff",
                                "&:hover": {
                                  background: "red",
                                },
                              },
                            ]}
                            onClick={() => handleCancellation("false")}
                          >
                            Cancel the request
                          </Button>
                        </Stack>
                      </Box>
                    ) : null}
                  </Grid> }
                </Grid>
              </Box>
              <Box
                className="card"
                sx={{ boxShadow: 3, p: 2, borderRadius: "10px" }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography fontWeight="600">Checklist</Typography>
                  {role === "counsellor" ? "" :
                  <AddCircleRounded
                    sx={{ cursor: "pointer",mr:"1rem" }}
                    onClick={() =>
                      dispatch(
                        setPopup({
                          show: true,
                          data: {
                            container: {
                              name: "addChecklist",
                              data: {
                                checklist: checklist,
                                setChecklist: setChecklist,
                                id: applicationData?._id,
                              },
                              dimensions: {
                                width: "500px",
                              },
                            },
                            type: "custom",
                          },
                        })
                      )
                    }
                  />}
                </Box>
                <Grid container spacing={3} sx={{ mt: 1 }}>
                  {checklist?.map((item, i) => (
                    <Grid item xs={6} key={i}>
                      <Box
                        key={i}
                        sx={{
                          mb: 2,
                          border: "1px solid grey",
                          borderRadius: "5px",
                        }}
                      >
                        <Stack
                          direction="row"
                          spacing={2}
                          sx={{
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Stack
                            direction="row"
                            spacing={2}
                            sx={{
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            {  loading ? (
                              <Box
                                component="img"
                                src={Images.standardLoader}
                                alt="standardLoader"
                                sx={{ width: "1.5rem", height: "1.5rem" }}
                              />
                            ) : (
                              
                              <Checkbox
                                checked={item?.isChecked}
                                 onClick={() => handleChecked(item)}
                              />
                            )}

                            <Box className="card">
                              <Typography
                                sx={{
                                  color: "grey",
                                  fontSize: "1rem",
                                  position: "relative",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  "&:hover .cancel-icon": {
                                    display: "block !important",
                                  },
                                }}
                              >
                                {item.name}
                                <Tooltip
                                  slotProps={{
                                    tooltip: {
                                      sx: {
                                        color: "#000",
                                        backgroundColor: "#fff",
                                        boxShadow: 2,
                                        fontSize: "0.8rem",
                                      },
                                    },
                                  }}
                                  title={item.desc}
                                  placement="bottom"
                                >
                                  <Info
                                    sx={{
                                      color: "grey",
                                      fontSize: "1rem",
                                      position: "relative",
                                      cursor: "pointer",
                                    }}
                                  />
                                </Tooltip>
                              </Typography>
                            </Box>

                            {item?.doc?.name ? (
                              <Link
                                to="/team/pdfPreview"
                                target="_blank"
                                onClick={() => {
                                  localStorage.setItem("docId", item?.doc?._id);
                                }}
                                style={{ textDecoration: "none" }}
                              >
                                <Typography className="font-semibold mb-5">
                                  {item?.doc?.name}
                                  {/* <img
                                     src={Images.pdfIconInChat}
                                     alt="pdf"
                                     style={{ marginLeft: "0.8rem" }}
                                   /> */}
                                </Typography>
                              </Link>
                            ) : null}
                          </Stack>
                          {role === "counsellor" ? "" :
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              marginRight: "5px !important",
                            }}
                          >
                            <ModeEditOutlinedIcon
                              sx={{ cursor: "pointer" }}
                              onClick={() =>
                                dispatch(
                                  setPopup({
                                    show: true,
                                    data: {
                                      container: {
                                        name: "editChecklist",
                                        data: {
                                          checklist: checklist,
                                          setChecklist: setChecklist,
                                          id: applicationData?._id,
                                          editData: item,
                                        },
                                        dimensions: {
                                          width: "500px",
                                        },
                                      },
                                      type: "custom",
                                    },
                                  })
                                )
                              }
                            />
                            <DeleteOutlineOutlinedIcon
                              sx={{ cursor: "pointer" }}
                              onClick={() => handleDelete(item?._id)}
                            />
                          </Box>
}
                        </Stack>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </div>
      ) : (
        <p>No application data found</p>
      )}
    </div>
  );
};

export default Application;
